import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { HelpCenterSpacer } from '../HelpCenterSpacer';
import { IHelpCenterSpacer } from '../types';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IHelpCenterSpacer = elementAttributesToProps(domNode);

  return Promise.resolve(<HelpCenterSpacer {...props} />);
};

export default rehydrator;
